import api from '@/services/api'

export default {
  /**
   * Get document categories
   * @return {Array} categories
   */
  async getAll () {
    try {
      const res = await api.get('/categories')
      return res.data
    } catch (error) {
      throw `Categories api service ${error}`
    }
  },

  /**
   * Create category
   * @param {Object} {name: String}
   * @return {Object} category
   */
  async create (category) {
    try {
      const res = await api.post('/categories', category)
      return res.data
    } catch (error) {
      throw `Categories api service ${error}`
    }
  },

  /**
   * Create categories
   * @param {Object} {name: String}
   * @return {Object} category
   */
  async update (category) {
    try {
      const res = await api.put('/categories/' + category.id, category)
      return res.data
    } catch (error) {
      throw `Categories api service ${error}`
    }
  },

  /**
   * Delete one category by id
   * @param {Number} id
   */
  async delete (id) {
    try {
      const res = await api.delete('/categories/' + id)
      return res.data
    } catch (error) {
      throw `Categories api service ${error}`
    }
  }
}